import type {ReactNode} from 'react'
import React from 'react'
import {FullWidthCarousel} from '@/products/flexible-web-toolkit/components/carousel/full-width-carousel'
import styles from './HeaderBlockWithCarousel.module.css'

interface HeaderBlockWithCarouselProps {
	className?: string
	children: ReactNode
	autoScrollEnabled?: boolean
	autoScrollDuration?: number
}

export const HeaderBlockWithCarousel = ({
	className = '',
	children = null,
	autoScrollEnabled = true,
	autoScrollDuration = 3000,
}: HeaderBlockWithCarouselProps): React.JSX.Element => {
	return (
		<div>
			<FullWidthCarousel
				autoScroll={autoScrollEnabled}
				autoScrollDuration={autoScrollDuration}
				className={`${className} ${styles.HeaderBlockCarousel}`}
			>
				{children}
			</FullWidthCarousel>
		</div>
	)
}
